<div class="layout">
    <div class="header-section">
        <img src="HomeBannerCastleOnly.png" fetchPriority="high" class="background-image">
        <div class="intro-container">
            <p class="intro-text-title">{{ 'imprint.header' | translate }}</p>
        </div>
    </div>
    <div class="text-section">
        <h1>{{ 'imprint.title' | translate }}</h1>
        <p>
            <span *ngFor="let line of ('imprint.publisher.breaks' | translate)">
                {{ line }}<br>
            </span>
        </p>
        <div class="chapter">
            <h1>{{ 'imprint.disclaimer.title' | translate }}</h1>
            <h3>{{ 'imprint.disclaimer.warning.title' | translate }}</h3>
            <p>
                <span *ngFor="let line of ('imprint.disclaimer.warning.breaks' | translate)">
                    {{ line }}
                </span>
            </p>
        </div>
    </div>
</div>
